export default __webpack_public_path__ + "static/media/mail.c57d4a7c.svg";